const pluginVersion = "12.1.0-pre";
const defaultOptions = {
  selectedSeries: 0
};

export { defaultOptions, pluginVersion };
